import { Navigate, Route, Routes } from 'react-router-dom';
import AppShell from './components/left-navigation/app-shell';
import AutoBenScreen from './screens/autoben/autoben';
import BenefitDetailScreenEntry from './screens/benefits/detail/benefit-detail-entry';
import BenefitListScreen from './screens/benefits/list/benefit-list';
import ChangeDetailScreen from './screens/requirements/change-detail';
import GroupDetailScreen from './screens/requirements/group-detail';
import RequirementsScreen from './screens/requirements/requirements';

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/benefits" element={<BenefitListScreen />} />
        <Route
          path="/benefits/:benefitId/version/:versionId"
          element={<BenefitDetailScreenEntry />}
        />
        <Route
          path="/benefits/:benefitId"
          element={<BenefitDetailScreenEntry />}
        />
        <Route
          path="/benefits/clone/:benefitId"
          element={<BenefitDetailScreenEntry />}
        />
        <Route path="/autoben" element={<AutoBenScreen />} />
        <Route path="/requirements" element={<RequirementsScreen />} />
        <Route
          path="/requirements/groups/:groupId"
          element={<GroupDetailScreen />}
        />
        <Route
          path="/requirements/changes/:changeId"
          element={<ChangeDetailScreen />}
        />
        <Route path="*" element={<Navigate to="/benefits" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
